export const REQUEST_CODE = {
    NODATA:40000, // 没数据
    SUCCESS: 20000, //成功
    ACTIVITY_END: 40010, //活动结束
    NO_PRODUCT: 60000, //无商品
    NO_NETWORK: -2000, //断网 getNetworkType 返回是 none 的情况
    TIME_OUT: -1000, //超时，先定义，目前超时只是弹出 '超时' 吐丝，返回中的结果参数为null
  };